import { render, staticRenderFns } from "./HelpDesks.vue?vue&type=template&id=64a97b55&scoped=true"
import script from "./HelpDesks.vue?vue&type=script&lang=js"
export * from "./HelpDesks.vue?vue&type=script&lang=js"
import style0 from "./HelpDesks.vue?vue&type=style&index=0&id=64a97b55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a97b55",
  null
  
)

export default component.exports